import React from 'react';
import { DragSource } from 'react-dnd'

const TaskButtonDraggable = ({children, option, canDrag, connectDragSource}) => {
  const bCanDrag = canDrag(option);
  const opacity =  bCanDrag ? 1 : 1;
  let backgroundColor = bCanDrag ? 'rgb(108,109,112)' : 'lightgray';

  return (
    <div ref={connectDragSource} className="task-draggable" 
      style={Object.assign({}, { opacity, backgroundColor })}>
      <div>
        {children}
      </div>
    </div>
  )
}

export default DragSource(
    'drag',
    {
      beginDrag: props => (props.option),
      endDrag(props, monitor) {
      },
      canDrag(props, monitor) {
        return props.canDrag(props.option);
      }
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
      didDrop: monitor.didDrop()
    }),
  )(TaskButtonDraggable)
  